import { FC } from 'react';
import { VyDialog } from '../../../../../components/new-design/feedback/VyDialog';
import { Box, Stack, Typography } from '@mui/material';
import { VyDivider } from '../../../../../components/new-design/atoms';
import { isNotNullOrUndefined } from '@vy/utils';
import { CustomFieldScalarValue } from '@vy/custom-fields-types';

type ViewCrmCustomFieldsDialogProps = {
  open: boolean;
  crmName: string;
  customFields: { label: string; value: CustomFieldScalarValue | null }[];
  onClose: () => void;
};

export const ViewCrmCustomFieldsDialog: FC<ViewCrmCustomFieldsDialogProps> = ({
  open,
  onClose,
  crmName,
  customFields,
}) => {
  return (
    <VyDialog
      open={open}
      onClose={onClose}
      label={`${crmName} Custom fields`}
      ctaText="OK"
      cancelButtonText="Cancel"
      onSubmit={onClose}
    >
      <Stack divider={<VyDivider />} sx={{
        gap: 2
      }}>
        <Stack direction="row">
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" sx={{
              fontWeight: 600
            }}>
              Vayu field
            </Typography>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" sx={{
              fontWeight: 600
            }}>
              Value
            </Typography>
          </Box>
        </Stack>
        {customFields.map((customField) => (
          <Stack direction="row" key={customField.label}>
            <Box sx={{ flex: 1 }}>
              <Typography variant="body2">{customField.label}</Typography>
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography variant="body2">
                {isNotNullOrUndefined(customField.value) ? customField.value : '---'}
              </Typography>
            </Box>
          </Stack>
        ))}
      </Stack>
    </VyDialog>
  );
};
